import { getRequest } from 'features/common'
import settings from 'settings'

export function getTags(): Promise<string[]> {
  return getRequest(`${settings.workspaceApiUrl}/tags`)
}
